module.exports = __webpack_public_path__ + "img/PANN Maritime Finance.ce182fe5.png";